import axios from 'axios';
import i18n from '../i18n';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

// URL patterns where we automatically append ?lang= so product copy is localised server-side
const LANG_AUTO_INJECT_PATTERNS = [
  /^\/products(\?|$|\/[^/]+(\?|$))/,               // /products, /products/{id}
  /^\/wallpaper\/products(\?|$)/,                  // /wallpaper/products
  /^\/public\/newest-products(\?|$)/,              // /public/newest-products
];

api.interceptors.request.use(config => {
  const token = localStorage.getItem('sd_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Auto-inject current UI language for product endpoints so buyers see listings in their own language.
  // If caller already specified lang (including empty string to opt-out of translation), respect it.
  try {
    if ((config.method || 'get').toLowerCase() === 'get') {
      const url = config.url || '';
      if (LANG_AUTO_INJECT_PATTERNS.some(rx => rx.test(url))) {
        const params = config.params || {};
        if (!('lang' in params)) {
          const currentLang = (i18n.language || 'en').split('-')[0];
          config.params = { ...params, lang: currentLang };
        }
      }
    }
  } catch (_) { /* no-op */ }
  return config;
});

export default api;
